module.exports = __webpack_public_path__ + "static/media/milan.45dba365.jpg";